<template>
  <div class="rd-fbar ss-bar" role="toolbar" :aria-label="$t('settings_shell.bar')">
    <div class="ss-bsearch" @focusin="searchOpen = true" @focusout="onSearchFocusOut">
      <label class="ss-srch">
        <v-icon size="16">mdi-magnify</v-icon>
        <span class="rd-visually-hidden">{{ $t("settings_shell.search") }}</span>
        <input
          ref="search"
          type="search"
          autocomplete="off"
          :value="ctl.ui.query"
          :placeholder="$t('settings_shell.search')"
          @input="ctl.ui.query = $event.target.value"
          @keydown.enter.prevent="openFirst"
          @keydown.esc.stop="clear"
        />
        <kbd>/</kbd>
      </label>
      <div v-if="query && searchOpen" class="ss-sres" role="listbox" :aria-label="$t('settings_shell.search')">
        <div v-if="!results.length" class="ss-sres__none">{{ $t("settings_shell.search_none", { q: query }) }}</div>
        <button
          v-for="(hit, i) in results"
          :key="`${hit.screen}-${hit.id}-${i}`"
          type="button"
          class="ui-sr"
          role="option"
          @mousedown.prevent
          @click="ctl.goTo(hit.screen, hit.id)"
        >
          <span class="ss-sr__i"><v-icon size="16">{{ icon(hit.screen) }}</v-icon></span>
          <span class="ss-sr__t">
            <b>{{ hit.text }}</b>
            <em>{{ hit.screenTitle }}</em>
          </span>
          <kbd v-if="i === 0">Enter</kbd>
        </button>
      </div>
    </div>

    <span class="rd-fbar__spacer"></span>

    <div class="ss-bstat">
      <button v-if="errorCount" type="button" class="ss-st ss-st--err" @click="ctl.focusFirstError()">
        <v-icon size="16">mdi-alert-outline</v-icon>
        {{ $t("settings_shell.status.errors", { n: errorCount }) }}
      </button>
      <span v-if="ctl.ui.saving" class="ss-st ss-st--busy" role="status"><i class="ss-spin"></i>{{ $t("settings_shell.saving") }}</span>
      <button
        v-else-if="ctl.changeCount"
        type="button"
        class="ss-st ss-st--dirty"
        data-open="changes"
        aria-haspopup="dialog"
        :aria-expanded="String(ctl.ui.pop === 'changes')"
        @click="ctl.ui.pop = ctl.ui.pop === 'changes' ? null : 'changes'"
      >
        <i class="ss-dot"></i>
        <b>{{ $t("settings_shell.status.unsaved", { n: ctl.changeCount }) }}</b>
        <u>{{ $t("settings_shell.review") }}</u>
      </button>
      <span v-else class="ss-st ss-st--ok" role="status">
        <v-icon size="16">mdi-check</v-icon>
        {{ $t("settings_shell.status.saved") }}
      </span>
      <button type="button" class="ui-btn" :disabled="!ctl.changeCount || ctl.ui.saving" @click="ctl.discard()">
        {{ $t("settings_shell.discard") }}
      </button>
      <button type="button" class="ui-btn ui-btn--primary" :disabled="!ctl.changeCount || ctl.ui.saving" @click="ctl.save()">
        <v-icon size="16">mdi-content-save-outline</v-icon>
        {{ $t("settings_shell.save") }}
        <kbd>Ctrl S</kbd>
      </button>
      <set-panel v-if="ctl.ui.pop === 'changes'" kind="changes" />
    </div>
  </div>
</template>

<script>
import { screenByKey } from "./settingsRegistry";
import SetPanel from "./parts/SetPanel.vue";

/** Lijepljiva traka: pretraga podešavanja, stanje snimanja (broj izmjena, pregled), Odbaci i Snimi. */
export default {
  name: "SettingsBar",
  components: { SetPanel },
  inject: { ctl: "settingsCtl" },
  data: () => ({ searchOpen: false }),
  computed: {
    query() {
      return this.ctl.ui.query.trim();
    },
    results() {
      return this.ctl.searchResults;
    },
    errorCount() {
      return this.ctl.errorCount;
    },
  },
  methods: {
    focusSearch() {
      const input = this.$refs.search;
      if (input) {
        input.focus();
        input.select();
      }
    },
    icon(screen) {
      return (screenByKey(screen) || {}).icon || "mdi-cog-outline";
    },
    onSearchFocusOut(event) {
      if (!event.relatedTarget || !event.currentTarget.contains(event.relatedTarget)) {
        this.searchOpen = false;
      }
    },
    clear() {
      if (this.ctl.ui.query) {
        this.ctl.ui.query = "";
      } else if (this.$refs.search) {
        this.$refs.search.blur();
      }
    },
    openFirst() {
      const first = this.results[0];
      if (first) {
        this.ctl.goTo(first.screen, first.id);
      }
    },
  },
};
</script>
